export default function getQueryParam(paramName) {
  return new URLSearchParams(window.location.search).get(paramName)
}
